import { render, staticRenderFns } from "./RewardBagde.vue?vue&type=template&id=2d1e94cc&"
import script from "./RewardBagde.vue?vue&type=script&lang=js&"
export * from "./RewardBagde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports